import { Box, Pagination } from '@mui/material'
import React from 'react'

const PaginationControls = ({totalCount, page, setPage, offset}) => {
  return (
    <div>

      <Box display="flex" justifyContent="center" mt={2} mb={2}>
        <Pagination
          count={Math.ceil(totalCount / offset)} // assuming 100 items per page
          page={page}
          onChange={(event, value) => setPage(value)}
          color="success"
        />
      </Box>

    </div>
  )
}

export default PaginationControls